var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1103 30V18.8081L17.3517 18.695C17.1172 18.6699 17 18.5652 17 18.381V17.8911H19.1103V16.3084C19.1103 15.5967 19.2024 14.9728 19.3866 14.4368C19.5708 13.8925 19.8304 13.4403 20.1654 13.0803C20.5003 12.7202 20.9023 12.4522 21.3712 12.2763C21.8402 12.0921 22.3594 12 22.9288 12C23.1884 12 23.448 12.0251 23.7076 12.0754C23.9756 12.1172 24.2142 12.18 24.4236 12.2638L24.3859 12.8416C24.3692 12.917 24.3315 12.9672 24.2729 12.9923C24.2226 13.0091 24.1472 13.0174 24.0468 13.0174C23.9463 13.0091 23.8165 12.9965 23.6574 12.9798C23.4983 12.9546 23.314 12.9421 23.1047 12.9421C22.6943 12.9421 22.3133 13.0049 21.9616 13.1305C21.6183 13.2477 21.321 13.4403 21.0698 13.7083C20.8186 13.9763 20.6218 14.328 20.4794 14.7634C20.3454 15.1905 20.2784 15.7181 20.2784 16.3461V17.8911H24.3357V18.783H20.3161V30H19.1103Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.b9277912a1333a3c8deac42c0353dd3d.svg";
export { ForwardRef as ReactComponent };